import { Store } from './store';

/**
 * Tema yönetimi: 'system' = data-theme niteliği YOK (CSS, prefers-color-scheme
 * medya bloklarıyla karar verir); 'light'/'dark' = açık kullanıcı seçimi,
 * <html data-theme="..."> olarak damgalanır ve localStorage'da kalıcıdır.
 */
export type ThemePreference = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'smg-theme';

function load(): ThemePreference {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

export const themePreference = new Store<ThemePreference>(load());

export function applyTheme(pref: ThemePreference): void {
  if (pref === 'system') {
    delete document.documentElement.dataset['theme'];
    localStorage.removeItem(STORAGE_KEY);
  } else {
    document.documentElement.dataset['theme'] = pref;
    localStorage.setItem(STORAGE_KEY, pref);
  }
  themePreference.set(pref);
}

/** Uygulama açılışında bir kez. */
export function initTheme(): void {
  applyTheme(themePreference.get());
}

export const THEME_LABELS: Record<ThemePreference, string> = {
  light: 'Açık',
  dark: 'Koyu',
  system: 'Sistem',
};

export const THEME_ICONS: Record<ThemePreference, string> = {
  light: 'ti ti-sun',
  dark: 'ti ti-moon',
  system: 'ti ti-device-desktop-cog',
};
